module.exports = __webpack_public_path__ + "static/index_banner-1-21eec0b1fbdf34df48df9a49dd1cc67c.jpg";